export interface Product {
  id: string;
  name: string;
  nameEn: string;
  category: string;
  image: string;
  origin: string;
  material: string;
  finish: string;
  thickness: string;
  size: string;
  color: string;
  applications: string[];
  summary: string;
  description: string;
}

export const productCategories = [
  "전체",
  "천연대리석",
  "화강석",
  "트래버틴",
  "인조석",
  "테라조",
  "세라믹",
];

export const products: Product[] = [
  {
    id: "carrara-white",
    name: "카라라 화이트",
    nameEn: "Carrara White",
    category: "천연대리석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20luxurious%20white%20carrara%20marble%20stone%20slab%20with%20soft%20grey%20veins%2C%20polished%20surface%20reflecting%20soft%20studio%20light%2C%20minimal%20neutral%20beige%20background%2C%20editorial%20material%20sample%20photography%2C%20high%20detail%2C%20clean%20professional%20composition&width=800&height=800&seq=stone-prod-01&orientation=squarish",
    origin: "이탈리아",
    material: "천연 대리석",
    finish: "폴리시드 (Polished)",
    thickness: "18mm / 20mm / 30mm",
    size: "2800 x 1600mm",
    color: "화이트 / 라이트 그레이",
    applications: ["주방 상판", "욕실 벽면", "거실 바닥", "테이블 상판"],
    summary: "부드러운 회색 결이 흐르는 클래식 화이트 대리석의 정석",
    description:
      "이탈리아 카라라 지역에서 채굴되는 대표적인 화이트 대리석으로, 은은한 회색 결이 자연스럽게 흐릅니다. 밝고 깨끗한 톤 덕분에 공간을 넓고 정돈된 느낌으로 만들어 주며, 주방 상판과 욕실 벽면 등 물과 습기에 노출되는 공간에서도 안정적인 광택을 유지합니다.",
  },
  {
    id: "statuario",
    name: "스타튜어리오",
    nameEn: "Statuario",
    category: "천연대리석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20premium%20white%20statuario%20marble%20slab%20with%20dramatic%20dark%20grey%20bolted%20veins%2C%20glossy%20polished%20stone%20surface%2C%20soft%20warm%20studio%20lighting%2C%20simple%20light%20grey%20background%2C%20fine%20art%20material%20photography%2C%20sharp%20detail&width=800&height=800&seq=stone-prod-02&orientation=squarish",
    origin: "이탈리아",
    material: "천연 대리석",
    finish: "폴리시드 (Polished)",
    thickness: "18mm / 20mm / 30mm",
    size: "2800 x 1600mm",
    color: "퓨어 화이트 / 차콜 그레이",
    applications: ["주방 아일랜드", "현관 바닥", "포인트 벽면", "호텔 로비"],
    summary: "강렬한 대비의 결이 공간의 중심이 되는 프리미엄 대리석",
    description:
      "순백의 바탕 위로 굵고 역동적인 차콜 그레이 결이 흐르는 최고급 대리석입니다. 한 장 한 장 결의 흐름이 달라 시공 시 그 자체가 예술 작품이 되며, 아일랜드 상판이나 현관, 로비 등 시선이 머무는 포인트 공간에 강력한 인상을 남깁니다.",
  },
  {
    id: "calacatta-gold",
    name: "칼라카타 골드",
    nameEn: "Calacatta Gold",
    category: "천연대리석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20luxury%20calacatta%20gold%20marble%20slab%20with%20warm%20golden%20and%20grey%20veins%2C%20polished%20glossy%20surface%2C%20elegant%20warm%20studio%20lighting%2C%20minimal%20cream%20background%2C%20high%20end%20stone%20sample%20photography%2C%20rich%20texture&width=800&height=800&seq=stone-prod-03&orientation=squarish",
    origin: "이탈리아",
    material: "천연 대리석",
    finish: "폴리시드 (Polished)",
    thickness: "18mm / 20mm / 30mm",
    size: "2800 x 1600mm",
    color: "아이보리 / 골드 / 그레이",
    applications: ["프리미엄 주방", "욕실 전체", "파우더룸", "리셉션 데스크"],
    summary: "골드빛 결이 고급스러움을 완성하는 럭셔리 대리석",
    description:
      "아이보리 바탕에 골드와 웜그레이 결이 어우러져 따뜻하면서도 고급스러운 분위기를 연출합니다. 빛을 받으면 결을 따라 은은하게 반짝여, 프리미엄 주방과 욕실, 상업 공간 리셉션 등 격식이 필요한 곳에 즐겨 사용됩니다.",
  },
  {
    id: "nero-marquina",
    name: "네로 마퀴나",
    nameEn: "Nero Marquina",
    category: "천연대리석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20deep%20black%20nero%20marquina%20marble%20slab%20with%20striking%20white%20veins%2C%20high%20gloss%20polished%20surface%2C%20dramatic%20studio%20lighting%2C%20dark%20neutral%20background%2C%20premium%20material%20photography%2C%20sharp%20contrast%20detail&width=800&height=800&seq=stone-prod-04&orientation=squarish",
    origin: "스페인",
    material: "천연 대리석",
    finish: "폴리시드 (Polished)",
    thickness: "18mm / 20mm / 30mm",
    size: "2800 x 1500mm",
    color: "블랙 / 화이트",
    applications: ["주방 상판", "욕실 포인트", "바 카운터", "벽난로"],
    summary: "검정 바탕에 흰 결이 선명한 시크한 대리석",
    description:
      "딥 블랙 바탕 위로 화이트 결이 강한 대비를 이루는 스페인산 대리석입니다. 무게감 있는 색감 덕분에 공간에 또렷한 중심을 만들어 주며, 밝은 수납장과 조합하면 현대적이고 세련된 주방을 완성할 수 있습니다.",
  },
  {
    id: "travertine-classic",
    name: "트래버틴 클래식",
    nameEn: "Travertine Classic",
    category: "트래버틴",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20warm%20beige%20classic%20travertine%20stone%20slab%20with%20natural%20horizontal%20texture%20and%20fine%20pores%2C%20honed%20matte%20surface%2C%20soft%20neutral%20studio%20light%2C%20plain%20cream%20background%2C%20editorial%20sample%20photography&width=800&height=800&seq=stone-prod-05&orientation=squarish",
    origin: "터키",
    material: "천연 트래버틴",
    finish: "혼드 (Honed)",
    thickness: "18mm / 20mm / 30mm",
    size: "2800 x 1500mm",
    color: "베이지 / 샌드",
    applications: ["욕실 바닥", "수영장 주변", "외벽", "포인트 벽면"],
    summary: "따뜻한 베이지 톤과 자연스러운 질감의 클래식 석재",
    description:
      "오랜 세월 쌓여 만들어진 자연의 층과 미세한 기공이 그대로 살아 있는 트래버틴입니다. 맨발로 닿아도 미끄럽지 않아 욕실 바닥이나 수영장 주변에 적합하며, 따뜻한 베이지 톤으로 공간에 편안한 온기를 더해 줍니다.",
  },
  {
    id: "silver-travertine",
    name: "실버 트래버틴",
    nameEn: "Silver Travertine",
    category: "트래버틴",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20cool%20grey%20silver%20travertine%20stone%20slab%20with%20linear%20natural%20striations%20and%20subtle%20pores%2C%20matte%20honed%20surface%2C%20neutral%20grey%20studio%20background%2C%20minimal%20high%20detail%20material%20photography&width=800&height=800&seq=stone-prod-06&orientation=squarish",
    origin: "터키",
    material: "천연 트래버틴",
    finish: "혼드 (Honed)",
    thickness: "18mm / 20mm / 30mm",
    size: "2800 x 1500mm",
    color: "실버 그레이 / 토프",
    applications: ["거실 바닥", "현관", "벽체", "상업 공간 바닥"],
    summary: "차분한 그레이 톤으로 모던한 공간에 어울리는 석재",
    description:
      "회색과 토프 톤이 은은하게 섞여 차분한 분위기를 만드는 트래버틴입니다. 선명한 무늬 없이 담백해 넓은 바닥에 시공해도 부담스럽지 않으며, 미니멀한 인테리어와 자연스럽게 어우러집니다.",
  },
  {
    id: "imperial-grey",
    name: "임페리얼 그레이",
    nameEn: "Imperial Grey",
    category: "화강석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20medium%20grey%20granite%20stone%20slab%20with%20fine%20even%20speckled%20grain%2C%20polished%20surface%2C%20clean%20neutral%20studio%20lighting%2C%20simple%20grey%20background%2C%20professional%20material%20sample%20photography&width=800&height=800&seq=stone-prod-07&orientation=squarish",
    origin: "한국",
    material: "천연 화강석",
    finish: "폴리시드 / 플레임드",
    thickness: "20mm / 30mm",
    size: "2000 x 1000mm",
    color: "미디엄 그레이",
    applications: ["외벽", "계단", "주차장 바닥", "조경"],
    summary: "강도가 높아 실내외 어디에나 안정적인 그레이 화강석",
    description:
      "균일한 조직과 뛰어난 내구성을 가진 화강석으로, 실외 환경에서도 변색과 마모에 강합니다. 담백한 그레이 톤이라 외벽이나 계단, 조경석 등 구조적인 요소에 두루 활용됩니다.",
  },
  {
    id: "black-pearl",
    name: "블랙 펄",
    nameEn: "Black Pearl",
    category: "화강석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20dark%20charcoal%20black%20pearl%20granite%20slab%20with%20fine%20silver%20mineral%20speckles%2C%20polished%20mirror%20surface%2C%20dramatic%20studio%20lighting%2C%20dark%20neutral%20background%2C%20premium%20stone%20photography&width=800&height=800&seq=stone-prod-08&orientation=squarish",
    origin: "인도",
    material: "천연 화강석",
    finish: "폴리시드 (Polished)",
    thickness: "20mm / 30mm",
    size: "2000 x 1000mm",
    color: "블랙 / 실버",
    applications: ["주방 상판", "바 카운터", "기념비", "포인트 벽면"],
    summary: "은은한 실버 광점이 박힌 묵직한 블랙 석재",
    description:
      "짙은 검정 바탕에 미세한 실버 광물 입자가 고르게 박혀 있어, 빛을 받으면 별이 반짝이는 듯한 질감을 보여 줍니다. 강도가 매우 높아 상판과 카운터처럼 마모가 잦은 곳에 특히 적합합니다.",
  },
  {
    id: "new-carrara-quartz",
    name: "뉴 카라라 퀄츠",
    nameEn: "New Carrara Quartz",
    category: "인조석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20white%20engineered%20quartz%20stone%20slab%20with%20soft%20grey%20veins%2C%20uniform%20non%20porous%20surface%2C%20bright%20clean%20studio%20lighting%2C%20simple%20warm%20white%20background%2C%20modern%20material%20sample%20photography&width=800&height=800&seq=stone-prod-09&orientation=squarish",
    origin: "한국",
    material: "엔지니어드 쿼츠",
    finish: "매트 / 폴리시드",
    thickness: "20mm / 30mm",
    size: "3200 x 1600mm",
    color: "화이트 / 라이트 그레이",
    applications: ["주방 상판", "아일랜드", "욕실 상판", "세면대"],
    summary: "흡수율이 낮아 관리가 쉬운 실용적 엔지니어드 스톤",
    description:
      "천연석의 무늬를 그대로 재현하면서도 흡수율이 거의 없어 오염과 얼룩에 강합니다. 주방 상판처럼 위생 관리가 중요한 공간에 적합하며, 넓은 판재로 이음새 없이 시공할 수 있어 깔끔한 마감이 가능합니다.",
  },
  {
    id: "marshmellow-quartz",
    name: "마쉬멜로우 퀄츠",
    nameEn: "Marshmellow Quartz",
    category: "인조석",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20warm%20cream%20beige%20engineered%20quartz%20stone%20slab%20with%20subtle%20soft%20texture%2C%20matte%20smooth%20surface%2C%20warm%20soft%20studio%20lighting%2C%20plain%20light%20neutral%20background%2C%20minimal%20interior%20material%20photography&width=800&height=800&seq=stone-prod-10&orientation=squarish",
    origin: "한국",
    material: "엔지니어드 쿼츠",
    finish: "매트 (Matte)",
    thickness: "20mm / 30mm",
    size: "3200 x 1600mm",
    color: "크림 베이지",
    applications: ["주방 상판", "식탁", "카페 카운터", "수납장 상판"],
    summary: "포근한 크림 톤으로 따뜻한 공간을 만드는 인조석",
    description:
      "우유빛 크림 톤에 은은한 입자감이 더해져 부드러운 인상을 줍니다. 무광 마감이라 빛 반사가 적어 편안한 분위기를 만들며, 우드 소재와 매치하면 따뜻한 주방이나 카페 공간에 잘 어울립니다.",
  },
  {
    id: "terrazzo-white",
    name: "테라조 화이트",
    nameEn: "Terrazzo White",
    category: "테라조",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20white%20terrazzo%20surface%20with%20small%20grey%20and%20beige%20stone%20chips%20scattered%20evenly%2C%20smooth%20matte%20finish%2C%20bright%20clean%20studio%20lighting%2C%20plain%20white%20background%2C%20contemporary%20material%20photography&width=800&height=800&seq=stone-prod-11&orientation=squarish",
    origin: "한국",
    material: "테라조 (무기질 바인더)",
    finish: "매트 (Matte)",
    thickness: "18mm / 20mm",
    size: "2400 x 1200mm",
    color: "화이트 / 멀티칩",
    applications: ["욕실 바닥", "현관", "주방 벽면", "상업 공간 바닥"],
    summary: "다양한 컬러칩이 리드미컬하게 박힌 테라조",
    description:
      "흰 바탕 위에 그레이와 베이지 컬러칩이 고르게 박혀 있어 밝으면서도 리듬감 있는 표면을 만듭니다. 이음새를 최소화해 넓게 시공하기 좋고, 상업 공간 바닥이나 욕실 등 활동이 많은 곳에서도 변색 없이 오래 유지됩니다.",
  },
  {
    id: "terrazzo-grey",
    name: "테라조 그레이",
    nameEn: "Terrazzo Grey",
    category: "테라조",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20cool%20grey%20terrazzo%20surface%20with%20dark%20and%20white%20aggregate%20chips%2C%20smooth%20matte%20finish%2C%20neutral%20studio%20lighting%2C%20plain%20light%20grey%20background%2C%20modern%20architectural%20material%20photography&width=800&height=800&seq=stone-prod-12&orientation=squarish",
    origin: "한국",
    material: "테라조 (무기질 바인더)",
    finish: "매트 (Matte)",
    thickness: "18mm / 20mm",
    size: "2400 x 1200mm",
    color: "미디엄 그레이 / 멀티칩",
    applications: ["로비 바닥", "계단", "카페 바닥", "외부 테라스"],
    summary: "도시적이고 모던한 무드의 그레이 테라조",
    description:
      "차분한 그레이 바탕에 다크·화이트 골재가 어우러져 정돈된 인상을 줍니다. 미끄럼 저항이 우수해 로비나 계단 등 사람이 많이 오가는 공간에 안전하게 적용할 수 있습니다.",
  },
  {
    id: "ceramic-marble-grey",
    name: "세라믹 마블 그레이",
    nameEn: "Ceramic Marble Grey",
    category: "세라믹",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20large%20format%20grey%20marble%20look%20ceramic%20tile%20surface%20with%20soft%20white%20veins%2C%20glossy%20rectified%20finish%2C%20soft%20neutral%20studio%20lighting%2C%20plain%20light%20background%2C%20minimal%20tile%20sample%20photography&width=800&height=800&seq=stone-prod-13&orientation=squarish",
    origin: "이탈리아",
    material: "포세린 세라믹",
    finish: "글로시 / 매트",
    thickness: "9mm / 12mm",
    size: "1600 x 3200mm",
    color: "그레이 / 화이트",
    applications: ["벽면", "바닥", "주방 백스플래시", "샤워실"],
    summary: "대리석 무늬를 얇고 가볍게 구현한 대형 세라믹",
    description:
      "천연 대리석의 무늬를 고해상도로 인쇄해 얇고 가벼운 대형 타일로 구현했습니다. 흡수율이 낮고 시공이 간편해 벽면과 바닥은 물론 주방 백스플래시와 샤워실까지 폭넓게 활용됩니다.",
  },
  {
    id: "ceramic-beige",
    name: "세라믹 베이지",
    nameEn: "Ceramic Beige",
    category: "세라믹",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20warm%20beige%20limestone%20look%20porcelain%20ceramic%20tile%20surface%20with%20soft%20stone%20texture%2C%20matte%20finish%2C%20warm%20soft%20studio%20lighting%2C%20plain%20cream%20neutral%20background%2C%20minimal%20material%20photography&width=800&height=800&seq=stone-prod-14&orientation=squarish",
    origin: "스페인",
    material: "포세린 세라믹",
    finish: "매트 (Matte)",
    thickness: "9mm / 12mm",
    size: "1200 x 2400mm",
    color: "베이지 / 샌드",
    applications: ["거실 바닥", "욕실 벽면", "주방 바닥", "베란다"],
    summary: "따뜻한 자연석 감성을 담은 베이지 세라믹",
    description:
      "석회암의 부드러운 질감을 담아낸 베이지 세라믹으로, 공간에 따뜻하고 차분한 분위기를 더합니다. 무광 표면이라 눈부심이 적고 관리가 쉬워 주거 공간 전반에 부담 없이 사용할 수 있습니다.",
  },
];